"use client";

import React, { useState } from "react";
import { MOVE_BRASIL_FAQ } from "@/app/config/moveBrasilFaq";
import styles from "@/styles/move-brasil.module.scss";

function getItemKey(groupId: string, index: number) {
	return `${groupId}-${index}`;
}

export const FaqSection: React.FC = () => {
	const [openItems, setOpenItems] = useState<Set<string>>(new Set());

	const toggleItem = (key: string) => {
		setOpenItems((prev) => {
			const next = new Set(prev);
			if (next.has(key)) {
				next.delete(key);
			} else {
				next.add(key);
			}
			return next;
		});
	};

	return (
		<section className={styles.faq}>
			<div className={styles.container}>
				<h2 className={styles.faqTitle}>Perguntas frequentes</h2>

				{MOVE_BRASIL_FAQ.map((group) => (
					<div key={group.id} className={styles.faqGroup}>
						<h3 className={styles.faqGroupTitle}>
							<span className={styles.faqGroupHighlight}>
								{group.highlight}
							</span>
							{" - "}
							{group.title}
						</h3>

						<div className={styles.faqList}>
							{group.items.map((item, index) => {
								const itemKey = getItemKey(group.id, index);
								const isOpen = openItems.has(itemKey);

								return (
									<article
										key={itemKey}
										className={`${styles.faqItem} ${
											isOpen ? styles.faqItemOpen : ""
										}`}
									>
										<button
											type="button"
											className={styles.faqQuestion}
											aria-expanded={isOpen}
											onClick={() => toggleItem(itemKey)}
										>
											<span>{item.question}</span>
											<span
												className={styles.faqIcon}
												aria-hidden="true"
											>
												+
											</span>
										</button>
										{isOpen && (
											<div className={styles.faqAnswer}>
												<p>{item.answer}</p>
											</div>
										)}
									</article>
								);
							})}
						</div>
					</div>
				))}
			</div>
		</section>
	);
};
